"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FuturesBalancesPositionsTableContainer = void 0;
var _reactRedux = require("react-redux");
var _reselect = require("reselect");
var _FuturesBalancesPositionsTable = require("./FuturesBalancesPositionsTable");
var _selectors = require("../../../redux/futures/selectors");
var _productsSelectors = require("../../../redux/selectors/productsSelectors");
var _instrumentActions = require("../../../redux/actions/instrumentActions");
var filteredProductsSelector = (0, _reselect.createSelector)(_selectors.openPositionsSelector, function (_, _ref) {
  var searchText = _ref.searchText;
  return searchText;
}, function (positions, searchText) {
  var filtered = positions.filter(function (p) {
    var instrumentSymbol = (p === null || p === void 0 ? void 0 : p.InstrumentSymbol) || '';
    return instrumentSymbol.toUpperCase().includes(searchText.toUpperCase());
  });

  // Sort by DateTimeOpened ascending (oldest first)
  return filtered.sort(function (a, b) {
    return new Date(a.DateTimeOpened) - new Date(b.DateTimeOpened);
  });
});
var mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    loading: state.apexCore.product.fetching,
    products: filteredProductsSelector(state, ownProps) || [],
    notionalProduct: (0, _productsSelectors.baseNotionalProductSelector)(state)
  };
};
var mapDispatchToProps = {
  selectInstrument: _instrumentActions.selectInstrument
};
var FuturesBalancesPositionsTableContainer = exports.FuturesBalancesPositionsTableContainer = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_FuturesBalancesPositionsTable.FuturesBalancesPositionsTable);